"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ticker = void 0;
const now = () => performance.now() / 1000;
class Ticker {
    constructor() {
        /** delta and now are in seconds */
        this.Tick = new Set();
        this.lasttime = 0;
        this.StopFlag = true;
        this.EndFlag = true;
        this.SkipFrame = 0;
    }
    Start() {
        if (!this.EndFlag)
            return;
        this.StopFlag = false;
        let skipframecounter = 0;
        const func = () => {
            this.EndFlag = false;
            if (this.StopFlag) {
                this.EndFlag = true;
                return;
            }
            requestAnimationFrame(func);
            if (skipframecounter > 0) {
                skipframecounter--;
                return;
            }
            skipframecounter = this.SkipFrame;
            const n = now();
            if (this.Tick) {
                for (const t of this.Tick)
                    t(n - this.lasttime, n);
            }
            this.lasttime = n;
        };
        this.lasttime = now();
        func();
    }
    Stop() {
        this.StopFlag = true;
    }
}
exports.Ticker = Ticker;
//# sourceMappingURL=Ticker.js.map